export default __webpack_public_path__ + "static/media/linkedin.ee4cc9e7.jpg";